<template>
  <div class="replace-logo">
    <el-card class="box-card clearfix">
      <el-row>
        <span>启动Logo：</span>
        <div class="button-box">
          <el-button class="pxy-primary" type="mini" @click="recoverFn">恢复默认</el-button>
          <el-button class="pxy-primary" type="mini" @click="clearLogoUrlFn">上传新的启动Logo</el-button>
        </div>
      </el-row>
      <div>
        <div class="logo-box logo-b" v-if="logoUrl !== ''">
          <el-image :src="logoUrl" fit="scale-down" style="max-width: 80%;margin: 0 10%;max-height:170px;"></el-image>
        </div>
        <div v-else>
          <el-upload style="width: 100%;margin: 10px 0;"
          class="pxy-upload"
          drag
          :action="uploadCourse.url"
          :http-request="courseUploadRequest"
          accept=".jpg,.png"
          name="add"
          :show-file-list="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip" style="color:#F56C6C;width: 100%!important;">
            图片建议尺寸273*215<br/>
            只能上传jpg/png文件，且不超过200kb
          </div>
        </el-upload>
          <div>
            <span class="title">定制启动Logo授权费用 ：</span>
            <span class="unit" style="color:orange ">￥</span>
            <span class="price"  style="color:orange ">{{appKeyLogoItem.price }}</span>
            <span class="unit"  style="color:orange "> {{appKeyLogoItem.priceUnit }}（进入应用后开始计费，退出应用停止计费）</span>
         </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
      logoUrl: '',
      uploadCourse: {
        url: '/pocAppli/logo/upload',
      },
      wsId: null,
      prodItemList:[],
      appKeyLogoItem:{}
    }
  },
  created() {
    this.getKey();
    this.getProcProdItem();
  },
  methods: {
    // 获取appkey
    getKey() {
      this.getRequest('/uacLarkxrWorkspace/getCredentialByUserId').then(res => {
        if(res.status == 200) {
          if(res.data.code === 1000) {
            let key = res.data.result.wsId;
            this.wsId = key;
            this.getLogo(key);
          }
        }
      })
    },
    // 获取logo
    getLogo(wsId) {
      axios.get(`${process.env.VUE_APP_LARKXR_URL}/getCstzLogoUrl?logoType=welcome&wsId=${wsId}&time=${new Date().getTime()}`,{
          responseType: 'arraybuffer'
        }).then(response => {
          return 'data:image/png;base64,' + btoa(new Uint8Array(response.data).reduce((data, key) => data + String.fromCharCode(key), ''))
        }).then( data =>{
          //console.log(data)
          this.logoUrl=data
        })
    },
    // 恢复默认
    recoverFn() {
      this.postRequestJson('/pocAppli/logo/clear').then(res => {
        if(res.status == 200) {
          if(res.data.code === 1000) this.$message.success('已恢复为默认启动Logo！');
          this.getLogo(this.wsId);
        }
      })
    },
    // 重新上传
    courseUploadRequest(f) {
      var _this = this;
      var param = new FormData(); //创建form对象
      var serviceItemList = [];
      serviceItemList.push(this.appKeyLogoItem)
      param.append('logoFile', f.file);//通过append向form对象添加数据
      for (let i = 0; i < serviceItemList.length; i++) {
        param.append("serviceItemList[" + i + "].id", serviceItemList[i].id);
        param.append("serviceItemList[" + i + "].itemName", serviceItemList[i].itemName);
        param.append("serviceItemList[" + i + "].prodId", serviceItemList[i].prodId);
        param.append("serviceItemList[" + i + "].chargeType2", serviceItemList[i].chargeType2);
        param.append("serviceItemList[" + i + "].priceByQuantity", serviceItemList[i].priceByQuantity);
        param.append("serviceItemList[" + i + "].price", serviceItemList[i].price);
        param.append("serviceItemList[" + i + "].priceUnit", serviceItemList[i].priceUnit);
        param.append("serviceItemList[" + i + "].note", serviceItemList[i].note);
        param.append("serviceItemList[" + i + "].deleteFlag", serviceItemList[i].deleteFlag);
      }

      axios.defaults.withCredentials = true;
      this.postMultipartRequest('/pocAppli/logo/upload',param).then(res => {
        if(res.status == 200) {
          if(res.data.code === 1000) {
            this.$message.success('上传成功！');
            this.getLogo(this.wsId);
          } else {
            this.$message.error(res.data.message);
          }
        }
      })
    },
    clearLogoUrlFn() {
      this.logoUrl = '';
    },
    getProcProdItem: function () {
      this.getRequest('/pocPriceItem/list', {"type": 3}).then(resp => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            this.prodItemList = resp.data.result;
            for (var i = 0; i < this.prodItemList.length; i++) {
              if (this.prodItemList[i].id == 917789292326027264) {
                this.appKeyLogoItem = this.prodItemList[i];
              }
            }
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error")
        }
      })
    },
  }
}
</script>
<style scoped>
  .replace-logo{
    margin-top: 20px;
    height: 100%;
  }
  .replace-logo .box-card {
    height: 360px;
  }
  .replace-logo .logo-b{
    width: 256px;
    height: 170px;
    vertical-align: top;
    margin-top: 20px;
  }
  .replace-logo .logo-box{
    width: 256px;
    height: 170px;
    line-height: 170px;
    border-radius: 5px;
    display: inline-block;
    vertical-align: top;
    border: 1px solid #DCDFE6;
    padding: 10px 0
  }
  .replace-logo .button-box {
    display: inline-block;
  }
 </style>
